import { store } from "../store";
import { homeLink, request } from "./cpln";

// Tasks that I was being invited to other orgs, as a user
export async function fetchMyOrgInvitations() {
  const { data } = await request({ url: "/task/-forme" });
  return data.items;
}

export async function acceptTask(taskId: string) {
  await request({ method: "post", url: `/task/${taskId}`, body: { answer: "accept" } });
}

// Tasks that I sent to other users, as the org owner
export async function fetchSentPendingTasks() {
  const body = {
    spec: {
      match: "all",
      terms: [
        {
          op: "=",
          property: "status",
          value: "pending",
        },
        {
          op: "=",
          property: "type",
          value: "inviteToOrg",
        },
      ],
    },
    kind: "task",
    fetch: "items",
  };

  const org = store.getState().context.org;
  const { data } = await request({ method: "post", url: `/org/${org}/task/-query`, body });
  return data.items;
}

export async function cancelSentTask(taskId: string) {
  const org = store.getState().context.org;
  await request({ method: "delete", url: `/org/${org}/task/${taskId}` });
}

export async function inviteUsers(emails: string[], groupLink: string) {
  if (emails.length < 1) return;
  const body: any = {
    emails,
  };
  if (!!groupLink) {
    body.groupLink = groupLink;
  }
  const link = `${homeLink("user")}/-invite`;
  const { data } = await request({ method: "post", url: link, body });
  return data;
}
